import React from "react";
import Login from "./Login";
import Quiz from "./Quiz";
import Thanks from "./Thanks";
import Main from "./../components/Main";
import Fullpage from "./../components/Fullpage";
import appStore from "./../stores/appStore";
import { observer } from "mobx-react";

@observer
class Home extends React.Component {
  render() {
    const { page } = appStore;
    return (
      <div>
        {page === "login" && <Main screen={<Login />} />}
        {page === "quiz" && <Main screen={<Quiz />} />}
        {page === "thanks" && <Fullpage screen={<Thanks />} />}
        {!page && <div>Cargando Cuestionario...</div>}
      </div>
    );
  }
}

export { Home as default };
